module.exports = {
      id: "apple-podcast-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#apple-podcast",
      toString: function () {
        return this.url;
      }
    }